<template>
  <div v-element-loader="{ endpoint: 'shoppinglist/loadAllConnectedToMachine' }" class="my-machines-connected-shoppinglists">
    <template v-if="shoppingLists">
      <oie-shopping-lists-table v-if="shoppingLists.length" :shopping-lists="shoppingLists"></oie-shopping-lists-table>
      <p v-else>
        {{ t('noConnectedShoppingLists') }}
      </p>
    </template>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import httpService from '../../../core/http-service'

export default {
  props: {
    id: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      shoppingLists: null
    }
  },
  async mounted() {
    this.getShoppingLists()
  },
  methods: {
    ...mapActions('myShoppingLists', ['selectShoppingList']),
    async getShoppingLists() {
      const machineId = parseInt(this.id.machineId, 10) // Use base 10 for conversion
      const machineOwnerId = parseInt(this.id.ownerId, 10) // Use base 10 for conversion

      if(!isNaN(machineId) && machineId !== 0) {
        const responseMachine = await httpService.get(`shoppinglist/loadAllConnectedToMachine/${machineId}`)
        this.shoppingLists = responseMachine.data
      } else if(!isNaN(machineOwnerId) && machineOwnerId !== 0) {
        const responseMachineOwner = await httpService.get(`shoppinglist/loadAllConnectedToMachineOwner/${machineOwnerId}`)
        this.shoppingLists = responseMachineOwner.data
      }
    }
  }
}
</script>

<style>
.my-machines-connected-shoppinglists {
  min-height: 5rem;
}
</style>
